// Importing required components and modules
import axios from "axios";
// Set the BASE_URL for API requests using the development URL from the env file.

// const BASE_URL = process.env.REACT_APP_API_URL;

const originValue = window.location.origin;
let BASE_URL = null;
if (originValue === "http://192.168.1.45:8888") {
  BASE_URL = "http://192.168.1.45:8888/api/";
} else if (originValue === "http://117.193.164.101:8888") {
  BASE_URL = process.env.REACT_APP_API_URL;
} else {
  BASE_URL = null;
}

// Create an axios instance with the default baseURL.

export default axios.create({
  baseURL: BASE_URL,
});

// Create another axios instance named 'instance' with a baseURL and custom headers.

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {},
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    const tockenValue = "Bearer " + token;
    if (token) {
      config.headers["Authorization"] = tockenValue;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Add a response interceptor to the 'instance' axios instance.

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.data === "User not Found") {
      localStorage.clear();
      window.location.replace("/");
    } else if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const accessToken = await refreshAccessToken();
      axiosPrivate.defaults.headers.common["Authorization"] =
        "Bearer " + accessToken;
      return axiosPrivate(originalRequest);
    } else throw error;
  }
);

export const axiosPrivate = instance;

// Function to refresh the access token.

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const data = { refresh: refreshToken };
  try {
    const response = await axios.post(BASE_URL + "token/refresh/", data);
    localStorage.setItem("accessToken", response?.data?.access);
    localStorage.setItem("refreshToken", response?.data?.refresh);
    return response?.data?.access;
  } catch (err) {
    localStorage.clear();
    window.location.replace("/");
  }
};
